import { Fragment } from "react";
import {
  getIconSrc,
  getInitialsIconSrc,
} from "../../../../utils/images/iconUtils";
import { getFutureDays } from "../../../../utils/date/DateUtils";
import CategoryPill from "../../badges/CategoryPill";
import { getLanguageContent } from "../../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../../utils/schemas/language/pages/personalFinancesSchema";

function RecurringTransactionCard({ transaction, onClick }) {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const getDisplayDate = (date) => {
    const days = getFutureDays(date);
    const statusCopy = content.overview.upcoming_transactions.status;

    if (days === 0) return statusCopy.today;
    if (days === 1) return statusCopy.tomorrow;
    return statusCopy.in_days.replace("{days}", days);
  };

  return (
    <Fragment>
      <div className="urt-card" onClick={onClick} style={{ cursor: "pointer" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "70%",
            }}
          >
            <img
              className="urt-card-icon"
              src={
                transaction.merchant_icon
                  ? getIconSrc(transaction.merchant_icon)
                  : getInitialsIconSrc(transaction.merchant)
              }
              alt={transaction.merchant}
            />
            <div>
              <p className="urt-card-merchant margin-reset padding-reset">
                {transaction.merchant}
              </p>
              <span className="urt-card-date">{transaction.frequency}</span>
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "space-between",
              textAlign: "center",
            }}
          >
            <strong
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: transaction.flow === "income" ? "#83B50D" : "#33393F",
              }}
            >
              {transaction.amount}
            </strong>
            <span
              style={{
                color: "#33393f",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                padding: "2px 8px",
                backgroundColor: "#ebf5ff",
                borderRadius: "10px",
              }}
            >
              {getDisplayDate(transaction.date)}
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default RecurringTransactionCard;
